import { birthdateFromAge } from '@@serverHelpers/index.mjs';
import { isRenteConjointRequired, isSpouseRequired } from '@@viewHelpers/validations/guaranteesPrevTns.js';
import { filter, propEq, propOr } from 'ramda';
import { useMemo } from 'react';
import { getReimbursementGraphContent } from './helpers/getReimbursementGraphContent.js';
import moment from 'moment';
import { parseDate } from '@@viewHelpers/validations/index.js';

const useNiveauxGarantiesTarifsPrevTnsRenteConjointForm = ({
  form,
  guarantees,
  getMiddleNumber,
  getMiddleText,
  annualIncome
}) => {
  const rConj = form.watch('guarantees.OPTION_RCONJ.selected');
  const spouse = form.watch('spouse');
  const rconjCap = form.watch('guarantees.RCONJ_CAP.value');

  const {
    OPTION_RCONJ,
    RCONJ_MAD,
    RCONJ_CAP
  } = guarantees;

  // Calcul dynamique de la part assureur pour RCONJ_CAP
  const rconjHealthInsurances = useMemo(() => {
    if (!rConj || !rconjCap) return [];

    const percentage = parseFloat(rconjCap) || 0;
    const insurerAmount = annualIncome * (percentage / 100);

    return [insurerAmount.toString()];
  }, [rConj, rconjCap, annualIncome]);

  const addSpouse = () => {
    form.setValue('spouse', {
      birthDate: null,
      editing: true,
      type: 'SPOUSE'
    });
    form.trigger();
  };

  const setEditingSpouse = (editing) => {
    form.setValue('spouse', {
      ...spouse,
      editing: editing
    });
  };

  const deleteSpouse = async () => {
    await form.setValue('spouse', null);
    form.trigger();
  };

  const minSpouseAge = getMiddleNumber('BENEFICIAIRE_DATE_NAISSANCE_AGE_MINIMUM_SPOUSE');
  const today = moment().endOf('day');
  const parsedEffectDate = parseDate(form.watch('offer.effectDate'));
  const effectDate = parsedEffectDate?.isValid() ? parsedEffectDate : today;
  let maxSpouseBirthDate = today;
  if (minSpouseAge > -1) {
    const calculatedMax = birthdateFromAge(
      minSpouseAge,
      effectDate,
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      false
    );
    if (calculatedMax?.isValid()) {
      maxSpouseBirthDate = moment.min(calculatedMax, today);
    }
  }
  const maxSpouseAge = getMiddleNumber('BENEFICIAIRE_DATE_NAISSANCE_AGE_MAXIMUM_SPOUSE');
  let minSpouseBirthDate = null;
  if (maxSpouseAge > -1) {
    const calculatedMin = birthdateFromAge(
      maxSpouseAge,
      effectDate,
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      true
    );
    if (calculatedMin?.isValid()) {
      minSpouseBirthDate = calculatedMin;
    }
  }

  const renteConjointCotisation = [
    {
      displayed: rConj,
      label: getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_RCONJ_LABEL'),
      monthlyAmount: propOr(0.0, 'monthlyPrice', RCONJ_CAP),
      yearlyAmount: propOr(0.0, 'annualPrice', RCONJ_CAP)
    }
  ];

  const rentConjReimbursementGraphContent = getReimbursementGraphContent(
    rconjHealthInsurances,
    propOr([], 'labelsRO', RCONJ_CAP),
    propOr([], 'RO', RCONJ_CAP)
  );

  return {
    rConj,
    minSpouseAge,
    maxSpouseAge,
    minSpouseBirthDate,
    maxSpouseBirthDate,
    spouse,
    addSpouse,
    setEditingSpouse,
    deleteSpouse,
    isSpouseRequired,
    isRenteConjointRequired,
    OPTION_RCONJ,
    RCONJ_MAD,
    renteConjointCotisation: filter(propEq('displayed', true), renteConjointCotisation),
    rconjHealthInsurances,
    rentConjReimbursementGraphContent
  };
};

export default useNiveauxGarantiesTarifsPrevTnsRenteConjointForm;
